import { Body, Box, Icon } from '../../widgets'
import { ButtonWrapper } from './'
import { forwardRef } from 'react'

export const Button = forwardRef(function Button({ leftIcon, rightIcon, iconSize = 32, children, ...props }, ref) {
  return (
    <ButtonWrapper {...props} ref={ref}>
      <Box
        gap={8}
        alignItems="center"
        fullWidth
        fullHeight
      >
        {leftIcon && <Icon
          icon={leftIcon}
          size={iconSize}
        />}
        <Box fullWidth fullHeight alignItems="center" justifyContent="center">
          <Body weight={600}>
            {children}
          </Body>
        </Box>
        {rightIcon && <Icon
          icon={rightIcon}
          size={iconSize}
        />}
      </Box>
    </ButtonWrapper>
  )
})